module.exports = __webpack_public_path__ + "img/approvalLogo.241d7c5b.svg";